import { useState } from 'react'
import Swal from 'sweetalert2';
import { useAdminInfo } from '../../../../../hooks/useAdminInfo';
import { addPromo } from '../../../Api/LoadPanel/LoadPanel';
import { Request } from '../../../Api/Requests/models';
import { approveRequest } from '../../../Api/Requests/Requests';

interface Props {
    request: Request
    onHide: () => void
    form: {
        recipient: string
        sender: string
    }
    setDropdownOpen: (dropdownOpen: boolean) => void
}

export const useAutoLoadPromo = ({ request, onHide, form, setDropdownOpen }: Props) => {
    // const { getTime } = useGetTimeForHistory()
    const { adminInfo } = useAdminInfo()
    const [loading, setLoading] = useState(false)

    const handleSuccess = async () => {
        await approveRequest({ id: request.id })
        onHide()
    }

    // CONFIRM ADD COINS WITH PROMO
    const confirmAddPromo = async ({ bonus }: { bonus: number }) => {
        if (loading) { return }
        if (request.amount < 1) { Swal.fire({ text: 'Debes introducir una cantidad (sin contar la promoción)' }); return }

        const formattedQuantity = Number(request.amount).toLocaleString("es-ES", {
            maximumFractionDigits: 2,
        });

        if (adminInfo?.useMaxLoadValue && adminInfo?.maxLoadValue && (Number(request.amount) >= adminInfo?.maxLoadValue)) {
            Swal.fire({
                html: `¿Estás por cargar <span style="color:var(--primary-color)">${formattedQuantity}</span> fichas al usuario <span style="color:var(--primary-color)">${request.Player?.platformUser}</span> con una bonificación de <span style="color:var(--primary-color)">${bonus}%</span>, deseas continuar?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: 'var(--main-color)',
                confirmButtonText: 'Si, Cargar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    handlePromo({ bonus });
                } else {
                    setLoading(false);
                    return;
                }

            });
        } else {
            handlePromo({ bonus });
        }
    }



    // MAIN FUNCTION
    const handlePromo = async ({ bonus = 10 }: { bonus: number }) => {
        setLoading(true)

        setDropdownOpen(false);
        try {
            const result = await addPromo({
                name: request.Player?.platformUser,
                quantity: request.amount.toString(),
                bonus: bonus,
                destinationAccountName: form.recipient ?? '',
                senderName: form.sender
            })

            if (result?.data?.success) {
                Swal.fire({ icon: 'success', text: `${request.amount} fichas cargadas a ${request.Player?.platformUser} con una bonificación de ${bonus}%` })
                handleSuccess()
            } else {
                const errorMessage = result?.response?.data?.message ?? 'Ha habido un error. Reinicia e intenta de nuevo.'
                Swal.fire({ icon: 'error', text: errorMessage });
            }

        } catch (error: any) {
            let errorMessage = error?.response?.data?.message ?? 'ERROR: No se ha podido cargar, verifica tu conexión y que tengas fichas disponibles.'
            Swal.fire({ icon: 'error', text: errorMessage, allowOutsideClick: false, allowEscapeKey: false });
        } finally {
            setLoading(false)
        }
    }


    return { confirmAddPromo, loadingLoadPromo: loading }
}
